import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  useTheme,
  CircularProgress,
  TablePagination,
  Chip,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
  AppBar,
  Toolbar,
  ButtonGroup,
  Dialog, // ADD THIS
  DialogTitle, // ADD THIS
  DialogContent, // ADD THIS
  DialogActions, // ADD THIS
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterListIcon from "@mui/icons-material/FilterList";
import AppsIcon from "@mui/icons-material/Apps";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import PreviewIcon from "@mui/icons-material/LaunchOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

import { Navigate, useNavigate } from "react-router-dom";
import ConfirmDialog from "../ConfirmDialog";
import AddUserForm from "./AddUserForm";
import EditGroupForm from "./EditGroupForm";
import AddGroupForm from "./AddGroupForm";
import AddCustomGroupForm from "./AddCustomGroupForm";
import EditUserForm from "./EditUserForm";
import { formatReadableDate } from "../../utils/formatDate";
import AddAppForm from "./AddAppForm";
import EditAppForm from "./EditAppForm";
import AssignUsers from "./AssignUsers";
import UnassignUsers from "./UnassignUsers";
import GroupDetailView from "./groupDetails/GroupDetailView";
import GroupCustomerDetailView from "./customerGroupDetails/GroupCustomerDetailView";
import { sortAlphabetically } from "../../utils/sortAlphabetically";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../utils/axiosInstance";
import AuditPasswordDialog from "./AuditPasswordDialog";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Collapse } from "@mui/material";

// burger menu
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { getUIDescription } from "./customerGroupDetails/AssigningCustomerGroupDevice";

import DeviceAuditReport from "./DeviceAuditReport";

export default function SiteAdmin({ refreshSidebar }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");

  const [loadingAction, setLoadingAction] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [loadingGroupUnits, setLoadingGroupUnits] = useState(false);
  const [loadingApps, setLoadingApps] = useState(false);
  const [loadingAudit, setLoadingAudit] = useState(false);
  const isLoading =
    loadingUsers ||
    loadingGroups ||
    loadingGroupUnits ||
    loadingAction ||
    loadingApps ||
    loadingAudit;

  const [viewMode, setViewMode] = useState(() => {
    const path = location.pathname;
    if (path.includes("/userList")) return "userList";
    if (path.includes("/PUG")) return "PUG";
    if (path.includes("/customer-group")) return "CustomerGroup";
    if (path.includes("/application")) return "Apps";
    if (path.includes("/audit")) return "Audit";
    return "userList";
  });

  const [selectedGroup, setSelectedGroup] = useState("all");
  const [availableGroups, setAvailableGroups] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showAddGroupForm, setShowAddGroupForm] = useState(false);
  const [showAddCustomGroupForm, setShowAddCustomGroupForm] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showAddAppForm, setShowAddAppForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showEditAppForm, setShowEditAppForm] = useState(false);
  const [showAssignUsers, setShowAssignUsers] = useState(false);
  const [showUnassignUsers, setShowUnassignUsers] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [groups, setGroups] = useState([]);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [showEditUserForm, setShowEditUserForm] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const [activeEditUserId, setActiveEditUserId] = useState(null);
  const [selectedGroupDetail, setSelectedGroupDetail] = useState(null);
  const [groupUnits, setGroupUnits] = useState([]);
  // const [filteredApps, setFilteredApps] = useState([]);
  const [apps, setApps] = useState([]);
  const [audits, setAudits] = useState([]);
  // used to refresh users when the add user api is successfully triggered
  const [onAddUser, setOnAddUser] = useState(false);
  const [onAddApp, setOnAddApp] = useState(false);

  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewDialogContent, setViewDialogContent] = useState("");
  const [viewDialogTitle, setViewDialogTitle] = useState("");

  const [auditPasswordOpen, setAuditPasswordOpen] = useState(false);
  const [isAuditAuthenticated, setIsAuditAuthenticated] = useState(false);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "g" });

  const [auditPagination, setAuditPagination] = useState({
    page: 1,
    limit: 50,
    total: 0,
    totalPages: 0,
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [methodFilter, setMethodFilter] = useState("all");

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  // 2. Add state
  const [showDeviceReport, setShowDeviceReport] = useState(false);

  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/userList")) setViewMode("userList");
    else if (path.includes("/PUG")) setViewMode("PUG");
    else if (path.includes("/customer-group")) setViewMode("CustomerGroup");
    else if (path.includes("/application")) setViewMode("Apps");
    else if (path.includes("/audit")) setViewMode("Audit");
  }, [location.pathname]);

  const handleAuditDeviceReportClick = () => {
    setShowDeviceReport(true);
  };



  // const sortAudit = (eventsToSort) => {
  //   if (!sortConfig.key) return eventsToSort;

  //   return [...eventsToSort].sort((a, b) => {
  //     const aValue = a[sortConfig.key];
  //     const bValue = b[sortConfig.key];

  //     // Boolean sorting
  //     if (typeof aValue === "boolean") {
  //       const aNum = aValue ? 1 : 0;
  //       const bNum = bValue ? 1 : 0;

  //       return sortConfig.direction === "asc" ? aNum - bNum : bNum - aNum;
  //     }

  //     // String sorting
  //     if (typeof aValue === "string") {
  //       return sortConfig.direction === "asc"
  //         ? aValue.localeCompare(bValue)
  //         : bValue.localeCompare(aValue);
  //     }

  //     // Number sorting
  //     if (typeof aValue === "number") {
  //       return sortConfig.direction === "asc"
  //         ? aValue - bValue
  //         : bValue - aValue;
  //     }

  //     return 0;
  //   });
  // };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const fetchUsers = useCallback(async () => {
    try {
      setLoadingUsers(true);
      let Api_return = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/users`,
      );

      const data = Api_return.data;
      const sortedUsers = sortAlphabetically(data, "name");
      setUsers(sortedUsers);
      // ✅ Also sort groups alphabetically
      const groups = [
        ...new Set(
          data.map((user) => String(user.group || "No Group")).filter(Boolean),
        ),
      ].sort((a, b) => a.localeCompare(b));

      setAvailableGroups(groups);
    } catch (err) {
      console.error("Error fetching devices:", err);
    } finally {
      setLoadingUsers(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [onAddUser]);

  const fetchGroups = useCallback(async (type) => {
    try {
      setLoadingGroups(true);
      let res;
      if (type === "all") {
        res = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/groups?companyId=${process.env.REACT_APP_COMPANY_ID}&type=geographical`,
          {
            withCredentials: true,
          },
        );

        const sortedData = sortAlphabetically(res.data, "name");
        setGroups(sortedData);
      } else {
        res = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/groups?companyId=${process.env.REACT_APP_COMPANY_ID}&type=${type}`,
          {
            withCredentials: true,
          },
        );

        if (type === "geographical") {
          const excludedIds = [
            "GROUP-2020-06-06-03-15-14-925896",
            "GROUP-2020-11-26-13-46-30-962731",
          ]; // 👈 IDs to exclude
          const filtered = await res.data.filter(
            (group) => !excludedIds.includes(group.id),
          );
          const sortedData = sortAlphabetically(filtered, "name");
          setGroups(sortedData);
        } else if (type === "customer") {
          setCustomerGroups(res.data);
        }
      }
    } catch (err) {
      console.error("Error fetching groups:", err);
    } finally {
      setLoadingGroups(false);
    }
  }, []);

  const fetchApps = useCallback(async () => {
    try {
      setLoadingApps(true);
      let Api_return = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/applications`,
        {
          withCredentials: true,
        },
      );
      const data = Api_return.data;

      setApps(data);

      // const groups = [
      //   ...new Set(
      //     data.map((app) => app.group || "No Group").filter(Boolean)
      //   ),
      // ];
      // setAvailableGroups(groups);
    } catch (err) {
      console.error("Error fetching apps:", err);
    } finally {
      setLoadingApps(false);
    }
  }, []);

  const fetchAudit = useCallback(async () => {
    try {
      setLoadingAudit(true);
      const params = {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: sortConfig.key || "createdAt",
        sortOrder: sortConfig.direction,
        search: query,
      };

      // Add date filters if they exist
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      // Add method filter if not "all"
      if (methodFilter && methodFilter !== "all") {
        params.method = methodFilter;
      }

      let response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/logs/getAuditLogs`,
        {
          params,
          withCredentials: true,
        },
      );

      console.log("Audit data received:", response?.data);
      setAudits(response?.data?.data || []);
      setAuditPagination(response?.data?.pagination || {});
    } catch (err) {
      console.error("Error fetching audit logs:", err);
      setAudits([]);
    } finally {
      setLoadingAudit(false);
    }
  }, [page, rowsPerPage, sortConfig, query, startDate, endDate, methodFilter]);

  useEffect(() => {
    fetchApps();
  }, [onAddApp]);

  useEffect(() => {
    if (viewMode === "PUG") {
      fetchGroups("geographical");
    } else if (viewMode === "CustomerGroup") {
      fetchGroups("customer");
    } else if (viewMode === "userList") {
      fetchGroups("all");
      fetchUsers(); // Add this to fetch users on mount
    } else if (viewMode === "Apps") {
      fetchGroups("all");
      fetchApps(); // Add this to fetch apps on mount
    } else if (viewMode === "Audit") {
      fetchAudit(); // ✅ This will now call fetchAudit instead of fetchGroups
    }
  }, [viewMode, fetchGroups, fetchUsers, fetchApps, fetchAudit]); // Add all dependencies

  // 🚀 OPTIMIZED: Use useMemo for filtered users
  const filteredUsers = useMemo(() => {
    if (viewMode !== "userList") return [];

    let filtered = users;

    // Apply search filter
    if (query) {
      const q = query.toLowerCase();
      filtered = filtered.filter((u) => {
        const name = u.name || "";
        const id = u.id || "";
        return name.toLowerCase().includes(q) || id.toLowerCase().includes(q);
      });
    }

    // Apply group filter
    if (selectedGroup !== "all") {
      filtered = filtered.filter((u) => {
        const userGroup = u.group?.id || "No Group";
        return userGroup === selectedGroup;
      });
    }

    return filtered;
  }, [users, query, selectedGroup, viewMode]);

  // 🚀 OPTIMIZED: Use useMemo for filtered groups
  const filteredGroups = useMemo(() => {
    if (viewMode !== "PUG" && viewMode !== "CustomerGroup") return [];

    let filtered = viewMode === "PUG" ? groups : customerGroups;

    // Apply search filter
    if (query) {
      const q = query.toLowerCase();
      filtered = filtered.filter((u) => {
        const name = u.name || "";
        const id = u.id || "";
        return name.toLowerCase().includes(q) || id.toLowerCase().includes(q);
      });
    }

    return filtered;
  }, [groups, customerGroups, query, viewMode]);

  const filteredApps = useMemo(() => {
    if (viewMode !== "Apps") return [];

    let filtered = apps;

    // // Apply search filter
    if (query) {
      const q = query.toLowerCase();
      filtered = filtered.filter((u) => {
        const name = u.name || "";
        const description = u.description || "";
        const id = u.id || "";
        return (
          name.toLowerCase().includes(q) ||
          description.toLowerCase().includes(q) ||
          id.toLowerCase().includes(q)
        );
      });
    }

    return filtered;
  }, [apps, query, viewMode]);

  // const filteredAudits = useMemo(() => {
  //   if (viewMode !== "Audit") return [];

  //   let filtered = audits;

  //   // // Apply search filter
  //   if (query) {
  //     const q = query.toLowerCase();
  //     filtered = filtered.filter((u) => {
  //       const username = u.username || "";
  //       const endpoint = u.endpoint || "";
  //       const id = u.id || "";
  //       const method = u.method || "";
  //       const action = u.action || "";
  //       const table = u.table || "";
  //       const createdAt = u.table || "";
  //       return (
  //         username.toLowerCase().includes(q) ||
  //         endpoint.toLowerCase().includes(q) ||
  //         id.toLowerCase().includes(q) ||
  //         method.toLowerCase().includes(q) ||
  //         action.toLowerCase().includes(q) ||
  //         table.toLowerCase().includes(q) ||
  //         createdAt.toLowerCase().includes(q)
  //       );
  //     });
  //   }

  //   return filtered;
  // }, [audits, query, viewMode]);

  const handleViewClick = (content, title) => {
    setViewDialogContent(
      typeof content === "object"
        ? JSON.stringify(content, null, 2)
        : String(content || "N/A"),
    );
    setViewDialogTitle(title);
    setViewDialogOpen(true);
  };

  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMethodFilter("all");
    setQuery("");
  };


  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setViewDialogContent("");
    setViewDialogTitle("");
  };

  // Reset page when filters change
  useEffect(() => {
    setPage(0);
  }, [query, selectedGroup, viewMode]);

  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  const handleGroupFilter = (e) => {
    setSelectedGroup(e.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const refreshUsers = () => {
    fetchUsers();
  };

  const refreshGroups = (type) => {
    fetchGroups(type);
  };
  const refreshApps = () => {
    fetchApps();
  };

  const refreshAudits = () => {
    fetchAudit();
  };

  const addUser = () => {
    setShowAddForm(true);
  };

  const editUser = (user) => {
    setSelectedUser(user);
    setShowEditForm(true);
  };

  const handleAddGroupSubmit = (newGroup) => {
    if (!newGroup) return;
    setGroups((prev) => [...prev, newGroup]);
    setShowAddGroupForm(false);
    refreshSidebar();
  };

  const handleAddCustomGroupSubmit = (newGroup) => {
    if (!newGroup) return;
    setCustomerGroups((prev) => [...prev, newGroup]);
    setShowAddCustomGroupForm(false);
  };
  const handleAddAppSubmit = (newApp) => {
    if (!newApp) return;
    setApps((prev) => [...prev, newApp]);
    setShowAddAppForm(false);
  };
  const handleFormSubmit = (newUserFromApi) => {
    if (!newUserFromApi) return;

    const newUser = {
      id: newUserFromApi.id,
      name: newUserFromApi.name,
      email: newUserFromApi.email,
      phone: newUserFromApi.phone || "",
      date_created: newUserFromApi.date_created || new Date().toISOString(),
      group: newUserFromApi.group || { id: null, name: "No Group" },
    };

    setUsers((prev) => [...prev, newUser]);
    setShowAddForm(false);
  };

  const handleFormEdit = (updatedGroup) => {
    console.log("🔍 Enhanced edit - updatedGroup:", updatedGroup);

    if (!updatedGroup) return;

    setGroups((prevGroups) => {
      const groupExists = prevGroups.some(
        (group) => group.id === updatedGroup.id,
      );
      if (!groupExists) {
        console.log("⚠️ Group not found in groups array, adding it");
        return [...prevGroups, updatedGroup];
      }

      return prevGroups.map((group) => {
        if (group.id === updatedGroup.id) {
          return {
            ...group,
            ...updatedGroup,
          };
        }
        return group;
      });
    });
    if (viewMode === "PUG") {
      refreshSidebar();
    }
    if (viewMode === "CustomerGroup") {
      setCustomerGroups((prevGroups) => {
        const groupExists = prevGroups.some(
          (group) => group.id === updatedGroup.id,
        );
        if (!groupExists) {
          return [...prevGroups, updatedGroup];
        }

        return prevGroups.map((group) => {
          if (group.id === updatedGroup.id) {
            return {
              ...group,
              ...updatedGroup,
            };
          }
          return group;
        });
      });
    }

    setShowEditForm(false);
    setSelectedGroup(null);
  };

  const searchUserTable = () => {
    navigate("../site-admin/userList");
    setQuery("");
    setSelectedGroup("all");
    if (viewMode === "userList") {
      fetchUsers();
    }
  };

  const precisionUnitTable = () => {
    navigate("../site-admin/PUG");
    setQuery("");
    setSelectedGroup("all");

    if (viewMode === "PUG") {
      fetchGroups("geographical");
    }
  };

  const CustomerGroupTable = () => {
    navigate("../site-admin/customer-group");
    setQuery("");
    setSelectedGroup("all");

    if (viewMode === "CustomerGroup") {
      fetchGroups("customer");
    }
  };

  const ApplicationTable = () => {
    setQuery("");
    setSelectedGroup("all");

    navigate("../site-admin/application");

    if (viewMode === "Apps") {
      console.log("Reloading applications data...");
      fetchApps();
      // Add your applications fetch function here when available
    }
  };

  const AuditTable = () => {
    // Check if already authenticated
    if (isAuditAuthenticated) {
      navigate("../site-admin/audit");
      setQuery("");
      setSelectedGroup("all");
      [];
    } else {
      // Show password dialog
      setAuditPasswordOpen(true);
    }
  };

  // useEffect(() => {
  //   if (viewMode === "Audit") {
  //     fetchAudit();
  //   }
  // }, [
  //   viewMode,
  //   page,
  //   rowsPerPage,
  //   sortConfig.key,
  //   sortConfig.direction,
  //   query,
  //   fetchAudit,
  // ]);

  const onViewModeChange = (mode) => {
    setViewMode(mode);
    setQuery("");
    setSelectedGroup("all");

    switch (mode) {
      case "userList":
        navigate("../site-admin/userList");
        fetchUsers();
        break;

      case "PUG":
        navigate("../site-admin/PUG");
        fetchGroups("geographical");
        break;

      case "CustomerGroup":
        navigate("../site-admin/customer-group");
        fetchGroups("customer");
        break;

      case "Apps":
        navigate("../site-admin/application");
        console.log("Reloading applications data...");
        fetchApps();
        break;
      case "Audit":
        if (isAuditAuthenticated) {
          navigate("../site-admin/audit");
          console.log("Refreshing audit...");
          fetchAudit();
        } else {
          setAuditPasswordOpen(true);
        }
        break;
      default:
        console.warn(`Unknown view mode: ${mode}`);
    }
  };

  const handleUserDeleteClick = (user) => {
    setSelectedUser(user);
    setConfirmOpen(true);
  };

  const handleGroupDeleteClick = (group) => {
    setSelectedGroup(group);
    setConfirmOpen(true);
  };
  const handleAppDeleteClick = (app) => {
    setSelectedApp(app);
    setConfirmOpen(true);
  };
  const handleConfirmDeleteUser = async () => {
    try {
      setLoadingAction(true);
      await axios.delete(
        `${process.env.REACT_APP_API_GATEAWAY}/users/${selectedUser.id}`,
      );

      console.log("✅ User deleted:", selectedUser.id);
      setUsers((prevUsers) =>
        prevUsers.filter((user) => user.id !== selectedUser.id),
      );
      toast.success("✅ User deleted successfully!");
    } catch (error) {
      console.error(
        "❌ Error deleting user:",
        error.response?.data || error.message,
      );
      toast.error(error.response?.data?.message || "❌ Failed to delete user");
    } finally {
      setConfirmOpen(false);
      setSelectedUser(null);
      setLoadingAction(false);
    }
  };

  const handleConfirmDeleteGroup = async () => {
    try {
      setLoadingAction(true);
      await axios.delete(
        `${process.env.REACT_APP_API_GATEAWAY}/groups/${selectedGroup.id}`,
        {
          data: { UI_Description: `${getUIDescription()}\n Delete Group` },
        },
      );

      console.log("✅ Group deleted:", selectedGroup.id);

      if (viewMode === "PUG") {
        setGroups((prevGroups) =>
          prevGroups.filter((group) => group.id !== selectedGroup.id),
        );
        refreshSidebar();
      } else if (viewMode === "CustomerGroup") {
        setCustomerGroups((prevGroups) =>
          prevGroups.filter((group) => group.id !== selectedGroup.id),
        );
      }
      toast.success("✅ Group deleted successfully!");
    } catch (error) {
      console.error(
        "❌ Error deleting group:",
        error.response?.data || error.message,
      );
      toast.error(error.response?.data?.message || "❌ Failed to delete group");
    } finally {
      setConfirmOpen(false);
      setSelectedGroup(null);
      setLoadingAction(false);
    }
  };

  const handleConfirmDeleteApp = async () => {
    try {
      setLoadingAction(true);
      await axios.delete(
        `${process.env.REACT_APP_API_GATEAWAY}/applications/${selectedApp.id}`,
        {
          data: {
            UI_Description: `${getUIDescription()}\n Delete Application`,
          },
        },
      );

      console.log("✅ Application deleted:", selectedApp.id);
      setApps((prevApps) =>
        prevApps.filter((app) => app.id !== selectedApp.id),
      );
      toast.success("✅ Application deleted successfully!");
    } catch (error) {
      console.error(
        "❌ Error deleting app:",
        error.response?.data || error.message,
      );
      toast.error(
        error.response?.data?.message || "❌ Failed to delete application",
      );
    } finally {
      setConfirmOpen(false);
      setSelectedApp(null);
      setLoadingAction(false);
    }
  };

  const handleAuditPasswordSuccess = () => {
    setAuditPasswordOpen(false);
    setIsAuditAuthenticated(true);
    navigate("../site-admin/audit");
    setQuery("");
    setSelectedGroup("all");
    setViewMode("Audit");
    fetchAudit();
  };

  const getRefreshButtonText = () => {
    switch (viewMode) {
      case "userList":
        return "Refresh Users";
      case "PUG":
        return "Refresh Groups";
      case "CustomerGroup":
        return "Refresh Customer Groups";
      case "Apps":
        return "Refresh Applications";
      case "Audit":
        return "REFRESH AUDIT";
      default:
        return "Refresh";
    }
  };

  const getAddButtonText = () => {
    switch (viewMode) {
      case "userList":
        return "Add User";
      case "PUG":
        return "Add Group";
      case "CustomerGroup":
        return "Add Customer Group";
      case "Apps":
        return "Add Application";
      case "Audit":
        return;
      default:
        return "Add";
    }
  };

  const handleRefreshAction = () => {
    switch (viewMode) {
      case "userList":
        refreshUsers();
        break;
      case "PUG":
        refreshGroups("geographical");
        console.log("Refreshing groups...");
        break;
      case "CustomerGroup":
        refreshGroups("customer");
        console.log("Refreshing customer groups...");
        break;
      case "Apps":
        refreshApps();
        console.log("Refreshing applications...");
        break;
      case "Audit":
        console.log("Refreshing audit...");
        refreshAudits();
        break;
      default:
        console.log("Unknown view mode");
    }
  };

  const handleAddAction = () => {
    switch (viewMode) {
      case "userList":
        setShowAddForm(true);
        break;
      case "PUG":
        setShowAddGroupForm(true);
        console.log("Adding new group...");
        break;
      case "CustomerGroup":
        setShowAddCustomGroupForm(true);
        console.log("Adding new customer group...");
        break;
      case "Apps":
        console.log("Adding new application...");
        setShowAddAppForm(true);

        break;
      default:
        console.log("Unknown view mode");
    }
  };

  const editGroup = (group) => {
    setSelectedGroup(group);
    setShowEditForm(true);
  };

  const editApp = (app) => {
    setSelectedApp(app);
    setShowEditAppForm(true);
  };
  const handleAssignUsers = (app) => {
    setSelectedApp(app);
    setShowAssignUsers(true);
  };
  const handleUnassignUsers = (app) => {
    setSelectedApp(app);
    setShowUnassignUsers(true);
  };
  const editUserNew = (user) => {
    setSelectedUserForEdit(user);
    setActiveEditUserId(user.id);
    setShowEditUserForm(true);
  };

  const handleUserNameClick = (user) => {
    setSelectedUserForEdit(user);
    setShowEditUserForm(true);
  };

  const handleUserEditSubmit = (updatedUser) => {
    refreshUsers();
    // setUsers((prevUsers) =>
    //   prevUsers.map((user) => (user.id === updatedUser.id ? updatedUser : user))
    // );
  };
  const handleAppEditSubmit = () => {
    refreshApps();
  };

  const handleGroupNameClick = (group) => {
    setSelectedGroupDetail(group);
    setViewMode("GroupDetail");
    // fetchGroupUnits(group.id);
  };

  const handleBackFromGroupDetail = () => {
    const previousMode =
      selectedGroupDetail?.type === "customer" ? "CustomerGroup" : "PUG";
    setViewMode(previousMode);
    setSelectedGroupDetail(null);
    setGroupUnits([]);
  };

  const fetchGroupUnits = async (groupId) => {
    try {
      setLoadingGroupUnits(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/regions?groupId=${groupId}`,
        {
          params: { companyId: process.env.REACT_APP_COMPANY_ID },
        },
      );
      console.log("this is the response: ", response);

      setGroupUnits(response.data || []);
    } catch (err) {
      console.error("Error fetching group units:", err);
      setGroupUnits([]);
    } finally {
      setLoadingGroupUnits(false);
    }
  };

  const handleEditGroupFromDetail = () => {
    setSelectedGroup(selectedGroupDetail);
    setShowEditForm(true);
  };

  const handleEditApp = () => {
    setSelectedApp(selectedApp);
    setShowEditAppForm(true);
  };
  const handleAddRegion = () => {
    refreshSidebar();
  };

  const onDeleteRegion = () => {
    refreshSidebar();
  };

  const onDeleteTechnician = () => {
    refreshSidebar();
  };

  const handleAddTechnician = () => {
    refreshSidebar();
  };

  const paginatedUsers =
    viewMode === "userList"
      ? filteredUsers.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )
      : filteredUsers;

  // const sortedEvents = sortAudit(filteredAudits);
  // const paginatedAudits =
  //   viewMode === "Audit"
  //     ? sortedEvents?.slice(
  //         page * rowsPerPage,
  //         page * rowsPerPage + rowsPerPage
  //       )
  //     : filteredAudits;
  const paginatedAudits = viewMode === "Audit" ? audits : [];

  const renderTable = () => (
    <TableContainer
      sx={{
        flexGrow: 1,
        height:
          viewMode === "userList"
            ? { xs: "64vh", md: "65vh" }
            : { xs: "69vh", md: "69vh" },
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
            {viewMode === "userList" ? (
              <>
                {/* Mobile expand button column */}
                <TableCell
                  sx={{
                    display: { xs: "table-cell", md: "none" },
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "12px 8px",
                    width: "50px",
                  }}
                >
                  Details
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "12px", sm: "15px", md: "16px" },
                    padding: { xs: "12px 8px", sm: "16px 12px" },
                  }}
                >
                  Name
                </TableCell>

                {/* Hide these columns on mobile */}
                <TableCell
                  sx={{
                    display: { xs: "none", md: "table-cell" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Login
                </TableCell>
                <TableCell
                  sx={{
                    display: { xs: "none", md: "table-cell" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Web Access
                </TableCell>
                <TableCell
                  sx={{
                    display: { xs: "none", md: "table-cell" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Parent Group
                </TableCell>
                <TableCell
                  sx={{
                    display: { xs: "none", md: "table-cell" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    display: { xs: "none", md: "table-cell" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Created At
                </TableCell>

                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                  Delete User
                </TableCell>
              </>
            ) : viewMode === "PUG" ? (
              <>
                <TableCell
                  sx={{
                    display: { xs: "table-cell", md: "none" },
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "12px 8px",
                    width: "50px",
                  }}
                >
                  Details
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Number of Units
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    padding: "8px",
                  }}
                >
                  Description
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Date Created
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Edit Group
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Delete Group
                </TableCell>
              </>
            ) : viewMode === "CustomerGroup" ? (
              <>
                {/* Mobile expand button column */}
                <TableCell
                  sx={{
                    display: { xs: "table-cell", md: "none" },
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "12px 8px",
                    width: "50px",
                  }}
                >
                  Details
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Customer Group Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Number of Units
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Description
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Date Created
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Delete Customer Group
                </TableCell>
              </>
            ) : viewMode === "Apps" ? (
              <>
                {/* Mobile expand button column */}
                <TableCell
                  sx={{
                    display: { xs: "table-cell", md: "none" },
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "12px 8px",
                    width: "50px",
                  }}
                >
                  Details
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  App Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  App Description
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Date Created
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Customer Group
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Edit App
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Add Users
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Remove Users
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Preview
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Delete App
                </TableCell>
              </>
            ) : viewMode === "Audit" ? (
              <>
                {/* Mobile expand button column */}
                <TableCell
                  sx={{
                    display: { xs: "table-cell", md: "none" },
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "8px 4px",
                    width: "40px",
                    minWidth: "40px",
                  }}
                >
                  Details
                </TableCell>

                {/* <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    padding: { xs: "8px 4px", md: "16px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                  onClick={() => handleSort("id")}
                >
                  ID
                  {sortConfig.key === "id" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell> */}

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    padding: { xs: "8px 4px", md: "16px" },
                  }}
                  onClick={() => handleSort("username")}
                >
                  Username
                  {sortConfig.key === "username" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    padding: { xs: "8px 4px", md: "16px" },
                    width: "20%",
                  }}
                  onClick={() => handleSort("endpoint")}
                >
                  Endpoint
                  {sortConfig.key === "endpoint" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                  onClick={() => handleSort("method")}
                >
                  Method
                  {sortConfig.key === "method" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Body
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Result
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  UI Description
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                >
                  Fleet/Unit
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                  onClick={() => handleSort("table")}
                >
                  Database
                  {sortConfig.key === "table" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                  onClick={() => handleSort("durationMs")}
                >
                  Duration
                  {sortConfig.key === "durationMs" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    display: { xs: "none", md: "table-cell" },
                  }}
                  onClick={() => handleSort("createdAt")}
                >
                  CreatedAt
                  {sortConfig.key === "createdAt" && (
                    <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                  )}
                </TableCell>
              </>
            ) : (
              <>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  Error
                </TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {viewMode === "userList" && paginatedUsers.length > 0 ? (
            paginatedUsers.map((user, index) => (
              <React.Fragment key={user.id}>
                {/* Main Row */}
                <TableRow
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": { backgroundColor: "#4a4d54" },
                  }}
                >
                  {/* Expand Button - Mobile Only */}
                  <TableCell
                    sx={{
                      display: { xs: "table-cell", md: "none" },
                      textAlign: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(user.id)}
                      sx={{ color: "white" }}
                    >
                      {expandedRows[user.id] ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  </TableCell>

                  {/* User Name - Always Visible */}
                  <TableCell align="center">
                    <Button
                      onClick={() => editUserNew(user)}
                      sx={{
                        width: "100%",
                        borderRadius: 0,
                        textTransform: "none",
                        justifyContent: "center",
                        padding: 0,
                        minWidth: 0,
                        backgroundColor: "transparent",

                        color:
                          selectedUserForEdit?.id === user.id
                            ? "#1565c0"
                            : "inherit",

                        textDecoration:
                          selectedUserForEdit?.id === user.id
                            ? "underline"
                            : "none",

                        fontWeight: "bold",
                        fontSize: { xs: "11px", sm: "14px", md: "15px" },

                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                          color: "#1565c0",
                        },
                      }}
                    >
                      {user.name}
                    </Button>
                  </TableCell>

                  {/* Desktop Columns - Hidden on Mobile */}
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    {user.username || "no username"}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Chip
                      label={user.application?.name || "No web access"}
                      color={user.application?.id ? "info" : "default"}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Chip
                      label={user.group?.name || "No Group"}
                      color={user.group?.id ? "primary" : "default"}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    {user.phone}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    {formatReadableDate(user.date_created)}
                  </TableCell>

                  {/* Delete Button - Always Visible */}
                  <TableCell align="center">
                    <Button
                      sx={{ borderRadius: 0 }}
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleUserDeleteClick(user)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>

                {/* Expandable Row - Mobile Only */}
                <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={3}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    }}
                  >
                    <Collapse
                      in={expandedRows[user.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ py: 2, px: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Login:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {user.username || "no username"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Web Access:
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              <Chip
                                label={
                                  user.application?.name || "No web access"
                                }
                                color={
                                  user.application?.id ? "info" : "default"
                                }
                                size="small"
                                variant="outlined"
                              />
                            </Box>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Parent Group:
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              <Chip
                                label={user.group?.name || "No Group"}
                                color={user.group?.id ? "primary" : "default"}
                                size="small"
                                variant="outlined"
                              />
                            </Box>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Phone:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {user.phone}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Created At:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {formatReadableDate(user.date_created)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))
          ) : viewMode === "PUG" && filteredGroups.length > 0 ? (
            filteredGroups.map((group, index) => (
              <React.Fragment key={group.id}>
                <TableRow
                  key={group.id}
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": {
                      backgroundColor: "#4a4d54",
                    },
                    fontSize: { xs: "11px", sm: "14px", md: "15px" },
                  }}
                >
                  <TableCell
                    sx={{
                      display: { xs: "table-cell", md: "none" },
                      textAlign: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(group.id)}
                      sx={{ color: "white" }}
                    >
                      {expandedRows[group.id] ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  </TableCell>

                  <TableCell>
                    <Button
                      onClick={() => handleGroupNameClick(group)}
                      sx={{
                        borderRadius: 0,
                        fontSize: { xs: "11px", sm: "14px", md: "15px" },
                        textAlign: "center",
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                        color: "inherit",
                        fontWeight: "normal",
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {group.name}
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {group.deviceCount}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {group.description}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    {formatReadableDate(group.date_created)}
                  </TableCell>

                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                      display: { xs: "none", md: "table-cell" },
                      fontWeight: "bold",
                    }}
                  >
                    <Button
                      sx={{ borderRadius: 0 }}
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => editGroup(group)}
                    >
                      Edit
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                      display: { xs: "none", md: "table-cell" }, // ADD THIS LINE
                    }}
                  >
                    <Button
                      sx={{
                        textAlign: "center",
                        fontSize: {
                          xs: "11px",
                          sm: "14px",
                          md: "15px",
                        },
                        borderRadius: 0,
                      }}
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleGroupDeleteClick(group)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={5}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    }}
                  >
                    <Collapse
                      in={expandedRows[group.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ py: 2, px: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Date Created :
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {formatReadableDate(group.date_created)}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Edit :
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              <Button
                                sx={{ borderRadius: 0 }}
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => editGroup(group)}
                              >
                                Edit
                              </Button>
                              <ConfirmDialog
                                open={confirmOpen}
                                onClose={() => setConfirmOpen(false)}
                                onConfirm={handleConfirmDeleteGroup}
                              />
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Delete :
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              <Button
                                sx={{
                                  borderRadius: 0,
                                  textAlign: "center",
                                  fontSize: {
                                    xs: "11px",
                                    sm: "14px",
                                    md: "15px",
                                  },
                                }}
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => handleGroupDeleteClick(group)}
                              >
                                Delete
                              </Button>

                              <ConfirmDialog
                                open={confirmOpen}
                                onClose={() => setConfirmOpen(false)}
                                onConfirm={handleConfirmDeleteGroup}
                              />
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))
          ) : viewMode === "CustomerGroup" && filteredGroups.length > 0 ? (
            filteredGroups.map((group, index) => (
              <React.Fragment key={group.id}>
                <TableRow
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": {
                      backgroundColor: "#4a4d54",
                    },
                  }}
                >
                  {/* Expand Button - Mobile Only */}
                  <TableCell
                    sx={{
                      display: { xs: "table-cell", md: "none" },
                      textAlign: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(group.id)}
                      sx={{ color: "white" }}
                    >
                      {expandedRows[group.id] ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  </TableCell>

                  <TableCell>
                    <Button
                      onClick={() => handleGroupNameClick(group)}
                      sx={{
                        borderRadius: 0,
                        fontSize: { xs: "11px", sm: "14px", md: "15px" },
                        textAlign: "center",
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                        color: "inherit",
                        fontWeight: "normal",
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {group.name}
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {group.deviceCount}
                  </TableCell>

                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {group.description}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {formatReadableDate(group.date_created)}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Button
                      sx={{ borderRadius: 0 }}
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleGroupDeleteClick(group)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>

                {/* Expandable Row - Mobile Only */}
                <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={5}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    }}
                  >
                    <Collapse
                      in={expandedRows[group.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ py: 2, px: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Date Created:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {formatReadableDate(group.date_created)}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Delete:
                            </Typography>
                            <Box sx={{ mt: 0.5 }}>
                              <Button
                                sx={{ borderRadius: 0 }}
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => handleGroupDeleteClick(group)}
                              >
                                Delete
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))
          ) : viewMode === "Apps" && filteredApps.length > 0 ? (
            filteredApps.map((app, index) => (
              <React.Fragment key={app.id}>
                {/* Main Row */}
                <TableRow
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": { backgroundColor: "#4a4d54" },
                  }}
                >
                  {/* Expand Button - Mobile Only */}
                  <TableCell
                    sx={{
                      display: { xs: "table-cell", md: "none" },
                      textAlign: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(app.id)}
                      sx={{ color: "white" }}
                    >
                      {expandedRows[app.id] ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  </TableCell>

                  {/* App Name - Always Visible */}
                  <TableCell
                    onClick={() => editApp(app)}
                    sx={{
                      textTransform: "none",
                      cursor: "pointer",
                      textAlign: "center",
                      minWidth: "auto",
                      color: "inherit",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {app.name}
                  </TableCell>

                  {/* Desktop Columns - Hidden on Mobile */}
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {app.description}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {formatReadableDate(app.date)}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {app?.group?.name}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    <Tooltip title="Edit App">
                      <IconButton onClick={() => editApp(app)} color="primary">
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Tooltip title="Add users">
                      <IconButton
                        onClick={() => handleAssignUsers(app)}
                        color="success"
                      >
                        <GroupAddIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Tooltip title="Remove Users">
                      <IconButton
                        onClick={() => handleUnassignUsers(app)}
                        color="error"
                      >
                        <GroupRemoveIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                    }}
                  >
                    <Tooltip title="Run App">
                      <IconButton
                        onClick={() => {
                          sessionStorage.removeItem("previewGroupId");
                          sessionStorage.removeItem("previewAppLogo");

                          if (app?.group && app?.group?.id) {
                            sessionStorage.setItem(
                              "previewGroupId",
                              app.group.id,
                            );
                          }

                          if (app?.logo) {
                            sessionStorage.setItem("previewAppLogo", app.logo);
                          }

                          let finalPath = "";

                          try {
                            finalPath = new URL(app.url).pathname;
                          } catch {
                            finalPath = app.url.startsWith("/")
                              ? app.url
                              : `/${app.url}`;
                          }

                          const finalUrl = `${window.location.origin}${finalPath}`;
                          window.open(finalUrl, "_blank");
                        }}
                        color="default"
                        disabled={!app.url}
                      >
                        <PreviewIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>

                  {/* Delete Button - Always Visible */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      display: { xs: "none", md: "table-cell" },
                    }}
                  >
                    <Tooltip title="Delete App">
                      <IconButton
                        onClick={() => handleAppDeleteClick(app)}
                        color="error"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>

                {/* Expandable Row - Mobile Only */}
                <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={3}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    }}
                  >
                    <Collapse
                      in={expandedRows[app.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ py: 2, px: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Description:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {app.description}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Date Created:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {formatReadableDate(app.date)}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Customer Group:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {app?.group?.name || "N/A"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Actions:
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                mt: 0.5,
                                flexWrap: "wrap",
                              }}
                            >
                              <Tooltip title="Edit App">
                                <IconButton
                                  onClick={() => editApp(app)}
                                  color="primary"
                                  size="small"
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Add users">
                                <IconButton
                                  onClick={() => handleAssignUsers(app)}
                                  color="success"
                                  size="small"
                                >
                                  <GroupAddIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Remove Users">
                                <IconButton
                                  onClick={() => handleUnassignUsers(app)}
                                  color="error"
                                  size="small"
                                >
                                  <GroupRemoveIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Run App">
                                <IconButton
                                  onClick={() => {
                                    sessionStorage.removeItem("previewGroupId");
                                    sessionStorage.removeItem("previewAppLogo");

                                    if (app?.group && app?.group?.id) {
                                      sessionStorage.setItem(
                                        "previewGroupId",
                                        app.group.id,
                                      );
                                    }

                                    if (app?.logo) {
                                      sessionStorage.setItem(
                                        "previewAppLogo",
                                        app.logo,
                                      );
                                    }

                                    let finalPath = "";

                                    try {
                                      finalPath = new URL(app.url).pathname;
                                    } catch {
                                      finalPath = app.url.startsWith("/")
                                        ? app.url
                                        : `/${app.url}`;
                                    }

                                    const finalUrl = `${window.location.origin}${finalPath}`;
                                    window.open(finalUrl, "_blank");
                                  }}
                                  color="default"
                                  disabled={!app.url}
                                  size="small"
                                >
                                  <PreviewIcon />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Delete App">
                                <IconButton
                                  onClick={() => handleAppDeleteClick(app)}
                                  color="error"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))
          ) : viewMode === "Audit" && paginatedAudits.length > 0 ? (
            paginatedAudits.map((audit, index) => (
              <React.Fragment key={audit.id}>
                {/* Main Row */}
                <TableRow
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    "&:hover": { backgroundColor: "#4a4d54" },
                  }}
                >
                  {/* Expand Button - Mobile Only */}
                  <TableCell
                    sx={{
                      display: { xs: "table-cell", md: "none" },
                      textAlign: "center",
                      padding: "8px 4px",
                      width: "40px",
                      minWidth: "40px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => toggleRowExpansion(audit.id)}
                      sx={{ color: "white", padding: "4px" }}
                    >
                      {expandedRows[audit.id] ? (
                        <ExpandLessIcon fontSize="small" />
                      ) : (
                        <ExpandMoreIcon fontSize="small" />
                      )}
                    </IconButton>
                  </TableCell>

                  {/* ID - Hidden on Mobile
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {audit.id}
                  </TableCell> */}

                  {/* Username - Always Visible */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                      padding: { xs: "8px 4px", md: "16px" },
                      maxWidth: { xs: "100px", sm: "auto" },
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: { xs: "nowrap", md: "normal" },
                    }}
                  >
                    {audit.username || "N/A"}
                  </TableCell>

                  {/* Endpoint - Always Visible */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                      padding: { xs: "8px 4px", md: "16px" },
                      maxWidth: { xs: "120px", sm: "auto" },
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: { xs: "nowrap", md: "normal" },
                    }}
                  >
                    {audit.endpoint || "N/A"}
                  </TableCell>

                  {/* Desktop Columns - Hidden on Mobile */}
                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {audit.method || "N/A"}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    <Button
                      sx={{ borderRadius: 0 }}
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        handleViewClick(audit.body, "Request Body")
                      }
                      disabled={!audit.body}
                    >
                      Body
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    <Button
                      sx={{ borderRadius: 0 }}
                      variant="outlined"
                      size="small"
                      onClick={() => handleViewClick(audit.result, "Result")}
                      disabled={!audit.result}
                    >
                      Result
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    <Box
                      onClick={() =>
                        handleViewClick(
                          audit.UI_Description,
                          "User Interface Description",
                        )
                      }
                      sx={{
                        cursor: audit.UI_Description ? "pointer" : "default",
                        color: audit.UI_Description
                          ? "primary.main"
                          : "text.secondary",
                        textDecoration: audit.UI_Description
                          ? "underline"
                          : "none",
                        "&:hover": audit.UI_Description
                          ? {
                            textDecoration: "underline",
                            opacity: 0.8,
                          }
                          : {},
                      }}
                    >
                      {audit.UI_Description
                        ? audit.UI_Description.length > 30
                          ? `${audit.UI_Description.substring(0, 30)}...`
                          : audit.UI_Description
                        : "N/A"}
                    </Box>
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {audit.targetType === "DEVICE" && audit.devices?.length ? (
                      audit.devices[0] // <-- pick the name
                    ) : audit.targetType === "FLEET" &&
                      audit.devices?.length ? (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>
                          handleViewClick(audit.devices, "Devices Affected")
                        }
                      >
                        {`View ${audit.devices.length} devices`}
                      </Button>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {audit.table || "N/A"}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {audit.durationMs ? `${audit.durationMs} ms` : "N/A"}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: { xs: "none", md: "table-cell" },
                      textAlign: "center",
                      fontSize: { xs: "11px", sm: "14px", md: "15px" },
                    }}
                  >
                    {formatReadableDate(audit.createdAt)}
                  </TableCell>
                </TableRow>

                {/* Expandable Row - Mobile Only */}
                <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={4}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#2f3136" : "#3a3c43",
                    }}
                  >
                    <Collapse
                      in={expandedRows[audit.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ py: 2, px: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                          }}
                        >
                          {/* <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              ID:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {audit.id}
                            </Typography>
                          </Box> */}

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Method:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {audit.method || "N/A"}
                            </Typography>
                          </Box>

                          {/* <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Action:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {audit.action || "N/A"}
                            </Typography>
                          </Box> */}

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Database:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {audit.table || "N/A"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Duration:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {audit.durationMs
                                ? `${audit.durationMs} ms`
                                : "N/A"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Created At:
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white" }}>
                              {formatReadableDate(audit.createdAt)}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#999", fontWeight: "bold" }}
                            >
                              Body & Result:
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                mt: 0.5,
                                flexWrap: "wrap",
                              }}
                            >
                              <Button
                                sx={{
                                  height: 40,
                                  width: "35%",
                                  borderRadius: 0,
                                }}
                                variant="outlined"
                                size="small"
                                onClick={() =>
                                  handleViewClick(audit.body, "Request Body")
                                }
                                disabled={!audit.body}
                              >
                                View Body
                              </Button>
                              <Button
                                sx={{
                                  height: 40,
                                  width: "35%",
                                  borderRadius: 0,
                                }}
                                variant="outlined"
                                size="small"
                                onClick={() =>
                                  handleViewClick(audit.result, "Result")
                                }
                                disabled={!audit.result}
                              >
                                View Result
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={
                  viewMode === "userList"
                    ? 7
                    : viewMode === "PUG"
                      ? 6
                      : viewMode === "CustomerGroup"
                        ? 5
                        : viewMode === "Apps"
                          ? 9
                          : viewMode === "Audit"
                            ? 10
                            : 1
                }
                align="center"
                sx={{ py: 3 }}
              >
                {query || selectedGroup !== "all"
                  ? `No data found matching the current filters`
                  : "No data found"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  if (showDeviceReport) {
    return <DeviceAuditReport onBack={() => setShowDeviceReport(false)} />;
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 0, sm: 0 },
        height: "100%",
        position: "relative",
      }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(187, 183, 183, 0.12)",
            backdropFilter: "blur(10px)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="#60a5fa" size={70} />
        </Box>
      )}

      <Paper
        elevation={4}
        sx={{
          p: {
            xs: 0.5, // Small screen
            sm: 1.5, // Medium screen
            md: 1.5, // Large screen
          },
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {viewMode !== "GroupDetail" ? (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {/* {viewMode === "PUG" && (
                  <IconButton onClick={searchUserTable} color="primary">
                    <ArrowBackIcon />
                  </IconButton>
                )} */}
                <Typography
                  variant="h5"
                  fontSize={{ xs: "1.15rem", sm: "2rem", md: "2rem" }}
                  fontWeight="bold"
                  marginLeft={{ xs: 1 }}
                >
                  {viewMode === "userList"
                    ? "Site Admin"
                    : viewMode === "PUG"
                      ? "Precision Unit Groups"
                      : viewMode === "CustomerGroup"
                        ? "Customer Group"
                        : viewMode === "Apps"
                          ? "Applications"
                          : viewMode === "Audit"
                            ? "Audit"
                            : ""}
                </Typography>
                {viewMode === "userList" ? (
                  <Chip
                    label={`${filteredUsers.length} users`}
                    color="primary"
                    size="small"
                  />
                ) : viewMode === "PUG" ? (
                  <Chip
                    label={`${filteredGroups.length} groups`}
                    color="primary"
                    size="small"
                  />
                ) : viewMode === "CustomerGroup" ? (
                  <Chip
                    label={`${filteredGroups.length} groups`}
                    color="primary"
                    size="small"
                  />
                ) : viewMode === "Apps" ? (
                  <Chip
                    label={`${filteredApps.length} apps`}
                    color="primary"
                    size="small"
                  />
                ) : viewMode === "Audit" ? (
                  <Chip
                    label={`${auditPagination.total || 0} audits`} // ✅ CORRECT - use server total
                    color="primary"
                    size="small"
                  />
                ) : null}

                {/* Filter indicator */}
                {(query || selectedGroup !== "all") && (
                  <Chip
                    icon={<FilterListIcon />}
                    label="Filtered"
                    color="white"
                    size="small"
                    variant="outlined"
                  />
                )}
              </Box>
              {/*------------------------------------------------- navtabs ----------------------------- */}
              <Box
                sx={{
                  display: "contents",
                  flexDirection: "column",
                  gap: 1.5,
                  width: "100vw",
                  marginLeft: "calc(-50vw + 50%)",
                }}
              >
                {/* Mobile: Burger Menu */}
                <Box
                  sx={{
                    display: { xs: "flex", sm: "none" },
                    justifyContent: "flex-end",
                    mb: 1,
                  }}
                >
                  <IconButton
                    onClick={() => setDrawerOpen(true)}
                    sx={{
                      color: "white",
                      bgcolor: "#374151",
                      "&:hover": { bgcolor: "#4b5563" },
                      borderRadius: 1,
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                </Box>

                {/* Mobile: Drawer Menu */}
                <Drawer
                  anchor="left"
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                  sx={{
                    display: { xs: "block", sm: "none" },
                    "& .MuiDrawer-paper": {
                      width: 280,
                      bgcolor: "#1f2937",
                      color: "white",
                    },
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 3,
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold">
                        Menu
                      </Typography>
                      <IconButton
                        onClick={() => setDrawerOpen(false)}
                        sx={{ color: "white" }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Button
                        fullWidth
                        startIcon={<GroupIcon />}
                        onClick={() => {
                          searchUserTable();
                          setDrawerOpen(false);
                        }}
                        sx={{
                          justifyContent: "flex-start",
                          px: 2,
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "14px",
                          bgcolor:
                            viewMode === "userList" ? "#1565c0" : "transparent",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "userList" ? "#1565c0" : "#374151",
                          },
                        }}
                      >
                        User List
                      </Button>

                      <Button
                        fullWidth
                        startIcon={<AccountTreeIcon />}
                        onClick={() => {
                          precisionUnitTable();
                          setDrawerOpen(false);
                        }}
                        sx={{
                          justifyContent: "flex-start",
                          px: 2,
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "14px",
                          bgcolor:
                            viewMode === "PUG" ? "#1565c0" : "transparent",
                          color: "white",
                          "&:hover": {
                            bgcolor: viewMode === "PUG" ? "#1565c0" : "#374151",
                          },
                        }}
                      >
                        Precision Unit Groups
                      </Button>

                      <Button
                        fullWidth
                        startIcon={<Diversity3Icon />}
                        onClick={() => {
                          CustomerGroupTable();
                          setDrawerOpen(false);
                        }}
                        sx={{
                          justifyContent: "flex-start",
                          px: 2,
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "14px",
                          bgcolor:
                            viewMode === "CustomerGroup"
                              ? "#1565c0"
                              : "transparent",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "CustomerGroup"
                                ? "#1565c0"
                                : "#374151",
                          },
                        }}
                      >
                        Customer Groups
                      </Button>

                      <Button
                        fullWidth
                        startIcon={<AppsIcon />}
                        onClick={() => {
                          ApplicationTable();
                          setDrawerOpen(false);
                        }}
                        sx={{
                          justifyContent: "flex-start",
                          px: 2,
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "14px",
                          bgcolor:
                            viewMode === "Apps" ? "#1565c0" : "transparent",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "Apps" ? "#1565c0" : "#374151",
                          },
                        }}
                      >
                        Applications
                      </Button>

                      <Button
                        fullWidth
                        startIcon={<FactCheckIcon />}
                        onClick={() => {
                          AuditTable();
                          setDrawerOpen(false);
                        }}
                        sx={{
                          justifyContent: "flex-start",
                          px: 2,
                          py: 1.5,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "14px",
                          bgcolor:
                            viewMode === "Audit" ? "#1565c0" : "transparent",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "Audit" ? "#1565c0" : "#374151",
                          },
                        }}
                      >
                        Audit
                      </Button>
                    </Box>
                  </Box>
                </Drawer>

                {/* Desktop/Tablet: AppBar with Tabs */}
                <AppBar
                  position="static"
                  sx={{
                    boxShadow: 0,
                    width: "100%",
                  }}
                >
                  {/* First Line: Navigation Tabs */}
                  <Toolbar
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      justifyContent: "right",
                      py: 0,
                      gap: 0,
                      bgcolor: "transparent",
                      minHeight: "auto !important",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "auto",
                        gap: 0,
                      }}
                    >
                      <Button
                        startIcon={<GroupIcon />}
                        onClick={searchUserTable}
                        sx={{
                          px: 3,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: { sm: "13px", md: "14px" },
                          minWidth: { sm: "50px", md: "90px", lg: "160px" },
                          height: 48,
                          borderRadius: 0,
                          bgcolor:
                            viewMode === "userList" ? "#1565c0" : "#374151",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "userList" ? "#1565c0" : "#4b5563",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        User List
                      </Button>

                      <Button
                        startIcon={<AccountTreeIcon />}
                        onClick={precisionUnitTable}
                        sx={{
                          px: 3,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: { sm: "13px", md: "14px" },
                          minWidth: { sm: "150px", md: "90px", lg: "160px" },
                          height: 48,
                          borderRadius: 0,
                          bgcolor: viewMode === "PUG" ? "#1565c0" : "#374151",
                          color: "white",
                          "&:hover": {
                            bgcolor: viewMode === "PUG" ? "#1565c0" : "#4b5563",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        Precision Unit Groups
                      </Button>

                      <Button
                        startIcon={<Diversity3Icon />}
                        onClick={CustomerGroupTable}
                        sx={{
                          px: 3,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: { sm: "13px", md: "14px" },
                          minWidth: { sm: "130px", md: "90px", lg: "160px" },
                          height: 48,
                          borderRadius: 0,
                          bgcolor:
                            viewMode === "CustomerGroup"
                              ? "#1565c0"
                              : "#374151",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "CustomerGroup"
                                ? "#1565c0"
                                : "#4b5563",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        Customer Groups
                      </Button>

                      <Button
                        startIcon={<AppsIcon />}
                        onClick={ApplicationTable}
                        sx={{
                          px: 3,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: { sm: "13px", md: "14px" },
                          minWidth: { sm: "130px", md: "90px", lg: "160px" },
                          height: 48,
                          borderRadius: 0,
                          bgcolor: viewMode === "Apps" ? "#1565c0" : "#374151",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "Apps" ? "#1565c0" : "#4b5563",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        Applications
                      </Button>

                      <Button
                        startIcon={<FactCheckIcon />}
                        onClick={AuditTable}
                        sx={{
                          px: 3,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: { sm: "13px", md: "14px" },
                          minWidth: { sm: "130px", md: "120px", lg: "160px" },
                          height: 48,
                          borderRadius: 0,
                          bgcolor: viewMode === "Audit" ? "#1565c0" : "#374151",
                          color: "white",
                          "&:hover": {
                            bgcolor:
                              viewMode === "Audit" ? "#1565c0" : "#4b5563",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                      >
                        Audit
                      </Button>
                    </Box>
                  </Toolbar>

                  {/* Second Line: Refresh + Add Buttons */}
                  <Toolbar
                    sx={{
                      justifyContent: "flex-end",
                      py: 0,
                      gap: { sm: 1, md: 1 },
                      bgcolor: "transparent",
                      minHeight: "auto !important",
                      mt: 1.5,
                    }}
                  >
                    <Box sx={{ display: "flex", gap: { sm: 2, md: 2 } }}>
                      {viewMode != "Audit" ? (
                        <>
                          <Button
                            variant="contained"
                            sx={{
                              bgcolor: "#00BFFF",
                              "&:hover": { bgcolor: "#18a5d4ff" },
                              height: 48,
                              textTransform: "none",
                              boxShadow: "none",
                              borderRadius: 0,
                              fontSize: { sm: "13px", md: "14px" },
                            }}
                            onClick={handleRefreshAction}
                          >
                            {getRefreshButtonText()}
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                            sx={{
                              height: 48,
                              textTransform: "none",
                              boxShadow: "none",
                              borderRadius: 0,
                              fontSize: { sm: "13px", md: "14px" },
                            }}
                            onClick={handleAddAction}
                          >
                            {getAddButtonText()}
                          </Button>
                        </>
                      ) : null}
                    </Box>
                  </Toolbar>
                </AppBar>
              </Box>
              {/*------------------------------------------------- navtabs ----------------------------- */}
            </Box>

            {/* Search and Filter Row */}
            {viewMode === "Audit" ? (
              <Box
                sx={{
                  px: 2,
                  mb: 2,
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
              >
                {/* INNER CONTAINER */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: { xs: "100%", sm: "50%" }, // 👈 KEY LINE
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      flexDirection: { xs: "row", sm: "row" },
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                        },
                      }}
                    >
                      <InputLabel>Method</InputLabel>
                      <Select
                        value={methodFilter}
                        onChange={(e) => setMethodFilter(e.target.value)}
                        label="Method"
                      >
                        <MenuItem value="all">All Methods</MenuItem>
                        <MenuItem value="POST">POST</MenuItem>
                        <MenuItem value="PUT">PUT</MenuItem>
                        <MenuItem value="DELETE">DELETE</MenuItem>
                      </Select>
                    </FormControl>
                    {/* Search - FULL WIDTH */}
                    <TextField
                      label="Search"
                      variant="outlined"
                      value={query}
                      onChange={handleSearch}
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                        },
                      }}
                    />
                  </Box>
                  {/* Start / End Date - 50 / 50 */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      flexDirection: { xs: "row", sm: "row" },
                    }}
                  >
                    <TextField
                      label="Start Date"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                        },
                      }}
                    />
                    <TextField
                      label="End Date"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                        },
                      }}
                    />
                  </Box>

                  {/* Method / Clear Filters - 50 / 50 */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      flexDirection: { xs: "row", sm: "row" },
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        bgcolor: "#00BFFF",
                        "&:hover": { bgcolor: "#18a5d4ff" },
                        textTransform: "none",
                        boxShadow: "none",
                        borderRadius: 0,
                        height: 40,
                        width: "100%",
                      }}
                      onClick={handleRefreshAction}
                    >
                      {getRefreshButtonText()}
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={handleClearFilters}
                      sx={{
                        height: 40,
                        width: "100%",
                        borderRadius: 0,
                        fontSize: "0.75rem",
                      }}
                    >
                      Clear Filters
                    </Button>

                    <Button
                      variant="contained"
                      onClick={handleAuditDeviceReportClick}
                      sx={{
                        height: 40,
                        width: "100%",
                        borderRadius: 0,
                        fontSize: "0.75rem",
                      }}
                    >
                      Check Device report
                    </Button>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 1, sm: 2, md: 2 },
                  mb: { xs: 1, sm: 2, md: 2 },
                  px: 2,
                  width: { xs: "100%", sm: "50%", md: "50%" },
                }}
              >
                <TextField
                  label="Search by Name..."
                  variant="outlined"
                  value={query}
                  onChange={handleSearch}
                  sx={{
                    flex: viewMode === "userList" ? "1 1 50%" : "1 1 100%",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 0, // ✅ correct target
                    },
                  }}
                  InputLabelProps={{
                    sx: { fontSize: "1rem" },
                  }}
                  inputProps={{
                    sx: { fontSize: "1rem" },
                  }}
                />
                {viewMode === "userList" && (
                  <FormControl
                    variant="outlined"
                    sx={{
                      flex: "1 1 50%",
                    }}
                  >
                    <InputLabel sx={{ fontSize: "1rem" }}>
                      Show Users by Groups
                    </InputLabel>
                    <Select
                      value={selectedGroup}
                      onChange={handleGroupFilter}
                      label="Show Users by Groups"
                      sx={{
                        fontSize: "1rem",

                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0, // root
                        },

                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: 0, // 🔥 THIS removes the last rounding
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: 0, // dropdown panel
                          },
                        },
                      }}
                    >
                      <MenuItem value="all">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            fontSize: "1rem",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0, // ✅ correct target
                            },
                          }}
                        >
                          <GroupIcon fontSize="small" />
                          All Groups
                        </Box>
                      </MenuItem>
                      {groups
                        .filter(
                          (group) =>
                            group.name !== "ROOT GROUP" &&
                            group.name !== "Precision Compression Admin",
                        )
                        .map((group) => (
                          <MenuItem
                            key={group.id}
                            value={group.id}
                            sx={{ fontSize: "1rem" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <GroupIcon fontSize="small" />
                              {group.name}
                            </Box>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            )}

            {/* Table */}
            {renderTable()}

            {viewMode === "userList" && (
              <TablePagination
                component="div"
                count={filteredUsers.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                sx={{}}
              />
            )}
            {viewMode === "Audit" && (
              <TablePagination
                component="div"
                count={auditPagination.total || 0} // Use server-side total
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
              />
            )}
          </>
        ) : /* Group Detail View */
          viewMode === "GroupDetail" &&
            selectedGroupDetail?.type === "customer" ? (
            <GroupCustomerDetailView
              group={selectedGroupDetail}
              onBack={handleBackFromGroupDetail}
              onEditGroup={handleEditGroupFromDetail}
              // onAddRegion={handleAddRegion}
              // onAddTechnician={handleAddTechnician}
              onViewModeChange={onViewModeChange}
            />
          ) : (
            <GroupDetailView
              group={selectedGroupDetail}
              onBack={handleBackFromGroupDetail}
              onEditGroup={handleEditGroupFromDetail}
              onAddRegion={handleAddRegion}
              onAddTechnician={handleAddTechnician}
              onViewModeChange={onViewModeChange}
              onDeleteRegion={onDeleteRegion}
              onDeleteTechnician={onDeleteTechnician}
            />
          )}
      </Paper>

      <AddGroupForm
        open={showAddGroupForm}
        onClose={() => setShowAddGroupForm(false)}
        onSubmit={handleAddGroupSubmit}
      />

      <AddCustomGroupForm
        open={showAddCustomGroupForm}
        onClose={() => setShowAddCustomGroupForm(false)}
        onSubmit={handleAddCustomGroupSubmit}
      />

      <AddUserForm
        open={showAddForm}
        onClose={() => setShowAddForm(false)}
        onSubmit={handleFormSubmit}
        onAddUser={() => setOnAddUser((prev) => !prev)}
      />
      <AddAppForm
        open={showAddAppForm}
        onClose={() => setShowAddAppForm(false)}
        onSubmit={handleAddAppSubmit}
        onAddApp={() => setOnAddApp((prev) => !prev)}
      />

      <EditAppForm
        open={showEditAppForm}
        onClose={() => {
          setShowEditAppForm(false);
        }}
        onSubmit={handleAppEditSubmit}
        app={selectedApp}
      />

      <AssignUsers
        open={showAssignUsers}
        onClose={() => {
          setShowAssignUsers(false);
        }}
        appId={selectedApp?.id}
      />
      <UnassignUsers
        open={showUnassignUsers}
        onClose={() => {
          setShowUnassignUsers(false);
        }}
        appId={selectedApp?.id}
      />

      <EditGroupForm
        open={showEditForm}
        onClose={() => setShowEditForm(false)}
        onSubmit={handleFormEdit}
        groupData={selectedGroup}
      />

      <EditUserForm
        open={showEditUserForm}
        onClose={() => {
          setShowEditUserForm(false);
          setSelectedUserForEdit(null);
        }}
        onSubmit={handleUserEditSubmit}
        userData={selectedUserForEdit}
      />
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        loading={loadingAction}
        onConfirm={
          viewMode === "userList"
            ? handleConfirmDeleteUser
            : viewMode === "Apps"
              ? handleConfirmDeleteApp
              : handleConfirmDeleteGroup
        }
      />
      {/* View Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={handleCloseViewDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{viewDialogTitle}</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            fullWidth
            value={viewDialogContent}
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            sx={{
              mt: 2,
              "& .MuiInputBase-root": {
                fontFamily: "monospace",
                fontSize: "14px",
                borderRadius: 0,
              },
            }}
            minRows={10}
            maxRows={20}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <AuditPasswordDialog
        open={auditPasswordOpen}
        onClose={() => setAuditPasswordOpen(false)}
        onSuccess={handleAuditPasswordSuccess}
      />
    </Box>
  );
}
